export const VIDEO_ANALYTIC_TYPES = [
  'crowd',
  'fight',
  'fire',
  'weapon',
  'facecover',
  'bag',
  'lying',
  'handsup',
  'fall',
];
